import { render, staticRenderFns } from "./MediaFileCard.vue?vue&type=template&id=40f5aa6e&scoped=true"
import script from "./MediaFileCard.vue?vue&type=script&lang=js"
export * from "./MediaFileCard.vue?vue&type=script&lang=js"
import style0 from "./MediaFileCard.vue?vue&type=style&index=0&id=40f5aa6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5aa6e",
  null
  
)

export default component.exports